const DEFAULT_LIGHT = '#FFFFFF';
const DEFAULT_DARK = '#000000';

const parseHexColor = (input?: string): [number, number, number] | null => {
  if (!input) {
    return null;
  }

  const sanitized = input.replace('#', '').trim();
  const normalized =
    sanitized.length === 3
      ? sanitized
          .split('')
          .map((char) => `${char}${char}`)
          .join('')
      : sanitized;

  if (!/^[0-9a-fA-F]{6}$/.test(normalized)) {
    return null;
  }

  return [0, 2, 4].map((index) => parseInt(normalized.slice(index, index + 2), 16)) as [
    number,
    number,
    number,
  ];
};

export const getContrastColor = (hexColor?: string): string => {
  const rgb = parseHexColor(hexColor);
  if (!rgb) {
    return DEFAULT_DARK;
  }

  const [r, g, b] = rgb;
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? DEFAULT_DARK : DEFAULT_LIGHT;
};
